import React from "react";
import { t } from "ttag";
import SitePackagesDialog from "../SitePackagesDialog";
import useStyles from "./About.style";

export default function AccountSubscription() {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className={classes.dropDownItem} onClick={handleOpen}>{t`Account`}</div>
      <SitePackagesDialog open={open} mode="status" onClose={handleClose} />
    </>
  );
}
